
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getArrayGames = (subcategory, stage) => {
    if (subcategory === "1D Array") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.Intro1D />;
            case "insertion-deletion":
                return <AllGames.InsertionDeletion1D />;
            case "searching":
                return <AllGames.Searching1D />;
            case "sorting":
                return <AllGames.sorting1D />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else if (subcategory === "2D Array") {
        switch (stage.name.toLowerCase()) {
            case "searching":
                return <AllGames.Searching2D />;
            case "sorting":
                return <AllGames.Sorting2D />;
            case "introduction":
                return <AllGames.Intro2D />;
            case "insertion-deletion":
                return <AllGames.InsertionDeletion2D />;
            case "variety of arrays":
                return <AllGames.VarietyOfArrays />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
